import { Component, Input } from '@angular/core';
import { FeatureGroup } from '../../generic/classes/featuregroup';
import { FeatureGroupComponent } from './featuregroup.component';

@Component({
    selector: 'feature-groups',
    styleUrls: ['./filter.component.scss'],
    template: `@for (featureGroup of featureGroups; track featureGroup) {
  <div
    class="filter-bar-part">
    <feature-group [featureGroup]="featureGroup"></feature-group>
  </div>
}`,
    standalone: true,
    imports: [FeatureGroupComponent],
})
export class FeatureGroupsComponent {
    @Input()
    featureGroups: FeatureGroup[];
}
